import React, { Fragment, useState, useEffect, useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CKEditor } from "ckeditor4-react";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { appContext } from "../../../Utils/context";
import records from '../../../Services/records'
import { toast, Slide } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPen, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import SweetAlert from 'react-bootstrap-sweetalert';
import Portal from "../../../Utils/portals";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Spinner,
    Button,
  
  } from "reactstrap";
  export default function Notes({uatId, list, setList}) {

    const {setNotesData} = useContext(appContext)

      const [data, setData] = useState({
          uat_id: uatId
      })
      const [notes, setNotes] = useState([])
      const [ckdEvt, setCkdEvt] = useState()
      const [btn, setBtn] = useState("Save")
      const [ specificId, setSpecificId] = useState(null)
      const [alert, setAlert] = useState(false)
      const [deleteRequesting, setDeleteRequesting] = useState(false)
      const [index,setIndex] = useState(false)
      

      const handleChange = (evt) => {
        setData({...data, note : evt.editor.getData()})
        
        setCkdEvt(evt.editor)
        
    }


   const state1 = {
    uat_id: uatId,
    info_type: "notes",   
    }

    useEffect(()=>{
      if(uatId !== undefined && uatId !== null){
        setNotesData(notes)}
    },[notes])

      useEffect(() => {

          if(uatId !== undefined){
            records.getNotes(state1).then((res) => {
                 setNotes(res.data)
                 // console.log("Notes are", res.data)
              }).catch((err) => {
                  console.log("error is", err)
              })
          }
          data.uat_id = uatId
          
      },[uatId])


      useEffect(() => {
           // console.log("note data", data)
      },[data])


      const addNotes = () => {
          btn === "Save" && (() => {
            if(uatId !== undefined && uatId !== null){
            records.addNotes(data).then((res) => {
               // console.log("notes response is", res.data)
                setNotes(res.data)
                setBtn("Save")
                ckdEvt.setData(' ')
                notify22("Note Added", "success") 

                const newList = list?.map((obj) => {
                    if(obj?.uat_id === uatId){
                      return {...obj, last_note: res?.data[0]?.note}
                    }
                    return obj
                  }
                  )
               
                  setList(newList)

            }).catch((err) => {
                console.log("error", err)
            })}
            else{
                if(data?.note){
                setNotes([...notes,{...data}])
                setBtn("Save")
                ckdEvt.setData(' ')
                notify22("Note Added", "success") }
                else{
                    notify22("Please add some content", "error") 
                }
            }
        }           
        )();
          btn === "Update" && (() => {
            if(uatId !== undefined && uatId !== null){
              //console.log("PUT object is", {record_id :specificId, ...data})
              records.updateNote({record_id :specificId, ...data}).then((res) => {
               // console.log("notes response is", res.data)
                setNotes(res.data)
                setBtn("Save")
                ckdEvt.setData(' ')
                notify22("Note Updated", "success") 

                const newList = list?.map((obj) => {
                    if(obj?.uat_id === uatId){
                      return {...obj, last_note: res?.data[0]?.note}
                    }
                    return obj
                  }
                  )
                  setList(newList)
              }).catch((err) => {
                  console.log("error is", err)
              })
        }else{
            const newData = [...notes]
            newData[index] = data;
            setIndex(false)
            setNotes(newData)
            setBtn("Save")
            ckdEvt.setData(' ')
            notify22("Note Added", "success")
        } }         
        )();
      
      }
      const deleteNote = () => {
            setDeleteRequesting(true)
            if(uatId !== undefined && uatId !== null){
          records.deleteNote({record_id: specificId, uat_id: uatId}).then((res) => {
            setNotes(res.data)
            notify22("Note Deleted", "success") 
            setAlert(false)
            const newList = list?.map((obj) => {
                if(obj?.uat_id === uatId){
                  return {...obj, last_note: res?.data[0]?.note}
                }
                return obj
              }
              )
           
              setList(newList)
            
          }).catch((err) => {
              console.log("error is", err)
              setDeleteRequesting(false)
              notify22(err.response.data.message, "error") 
          }).finally(() => setDeleteRequesting(false))}
          else{
            const newData = notes.filter((item, index) => index !== specificId);
            setNotes(newData)
            setAlert(false)
            notify22("Note Deleted", "success") 
            setDeleteRequesting(false)
          }
      }

      const clear = () => {

       // console.log("clear function call")
        ckdEvt.setData(' ')
        setBtn("Save")
   
    }

    const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,
      
    });
   

        return (
            <Fragment>
                <TransitionGroup>
                    <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                        <div >
                            <Row>
                                <Col md="12" >

                                    <Card className="main-card mb-1">
                                        <CardBody className="pb-1" >
                                            <CKEditor data= 'data '
                                          onLoaded={(evt) => setCkdEvt(evt.editor)}
                                             
                                            onChange={(evt) => handleChange(evt)}

                                            
                                            config={{
                                                height: "100px", 
                                                toolbar: [
                                                  ["Bold", "Italic",],
                                                  [
                                                    "Cut",
                                                    "Copy",
                                                    "Paste",
                                                    "Undo",
                                                    "Redo"
                                                  ],
                                                  [//"Styles",
                                                  "Format",
                                                  ]
                                                
                                                ]
                                              }}
                                            
                                              
                                            />
                                        </CardBody>
                                        <Row className="g-1">
                                            <Col  xs="2"></Col>
                                            <Col xs="4">
                                                <Button block outline className=" btn-wide me-2 mb-1 btn-transition"  color="secondary" onClick={(evt) => clear(evt)}>
                                                     Clear 
                                                </Button>
                                            </Col>
                                            <Col xs="4">
                                                <Button block outline className=" btn-wide mb-1 btn-transition"  color="primary" onClick={addNotes}>
                                                    {btn} 
                                                </Button>
                                            </Col>
                                            <Col xs="2"></Col>
                                        </Row>
                                    </Card>
                                </Col>
                                <Col md="12">
                                    <Card className="main-card mb-1">
                                        <CardHeader>Previous Notes</CardHeader>
                                        <CardBody className="pb-1">
                                            <div className="scroll-area-sm">
                                                <PerfectScrollbar>
                                              {notes.length> 0 ?
                                               ( notes?.map((v,k) => {
                                                  return(
                                                    <Row key={k} className="g-0">
                                                       {(uatId !== undefined && uatId !== null) &&<Col xs="3">
                                                            {v.datetime.slice(0,10)}: 
                                                        </Col> }
                                                        <Col xs="6">
                                                            <p dangerouslySetInnerHTML={{ __html: v?.note}} />
                                                        </Col>
                                                        <Col xs="3">
                                                            <Button className="border-0 btn-transition" outline color="primary" 
                                                           onClick={() => {
                                                            if(uatId !== undefined && uatId !== null) {
                                                              ckdEvt.setData(v?.note);
                                                              setBtn("Update");
                                                              setSpecificId(v?.id);
                                                              window.scrollTo(0,100);
                                                            }else
                                                             {
                                                              ckdEvt.setData(v?.note);
                                                              setBtn("Update");
                                                              setIndex(k);
                                                              window.scrollTo(0,100);
                                                             }
                                                          }}   
                                                            title=" Update">
                                                                <FontAwesomeIcon icon={faPen} size="1x"  />
                                                            </Button>
                                                            <Button className="border-0 btn-transition" outline color="danger" onClick={() => {setAlert(true);  (uatId !== undefined && uatId !== null)? setSpecificId(v?.id) :setSpecificId(k) }} title=" Delete">
                                                                <FontAwesomeIcon icon={faTrashAlt} size="1x"  />
                                                            </Button>
                                                            

                                                        </Col>
                                                    </Row>
                                                  )
                                              })
                                                )
                                                :(
                                                    <h5 className="text-center mt-5">Notes Not Added</h5>
                                                )
                                                }
                                               </PerfectScrollbar>
                                               { alert && (              
                                                    <Portal id="sweet-alert-portal">        
                                                        <SweetAlert r title="Are you sure?"  show={alert}
                                                        type="danger" onConfirm={deleteNote} onCancel={() => setAlert(false)}
                                                        showCancel confirmBtnText={deleteRequesting ? <><Spinner size="sm" /><span className="mb-2">{' '} Deleting</span> </>
                                                         : "Yes, delete it!"} confirmBtnBsStyle="danger" cancelBtnBsStyle= "info"/>
                                                    </Portal> 
                                                )} 
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                                   
                                    
                               
                        </div>
                    </CSSTransition>
                </TransitionGroup>
           </Fragment>
        )

        

}